import React from 'react';
import classNames from 'classnames';
import { AddressesProvider, useAddressesContext, ADDRESSES_TABS } from './AddressesContext';
import AddressList from './components/AddressList/AddressList';
import AddressEdit from './components/AddressEdit/AddressEdit';
import './AddressesContainer.scss';

const AddressesContainerContent = () => {
  const { currentTab, designSystemForms } = useAddressesContext();

  const renderCurrentTab = () => {
    switch (currentTab) {
      case ADDRESSES_TABS.EDIT:
        return <AddressEdit />;
      case ADDRESSES_TABS.LIST:
      default:
        return <AddressList />;
    }
  };

  return (
    <div className="AddressesContainer">
      <div className="AddressesContainer__container">
        <div
          className={classNames('AddressesContainer__content', {
            'AddressesContainer__content--formsDs20': designSystemForms,
          })}
        >
          {renderCurrentTab()}
        </div>
      </div>
    </div>
  );
};

const AddressesContainer = ({
  addresses = [],
  setAddresses,
  selectedAddress = null,
  onAddressSelect,
  onAddressSave,
  onBack,
  showContinueButton = false,
  onContinue,
  continueButtonText = 'Continue',
  selectionEnabled = false,
  addressFormSubmitButtonText = 'SAVE DETAILS',
  newAddressFormTitle = 'Add Address',
  designSystemForms = false,
  stayOnAddressFormAfterSave = false,
  onValidAddressChange,
  hideAddressFormBackLink = false,
}) => (
  <AddressesProvider
    addresses={addresses}
    setAddresses={setAddresses}
    selectedAddress={selectedAddress}
    onAddressSelect={onAddressSelect}
    onAddressSave={onAddressSave}
    onBack={onBack}
    showContinueButton={showContinueButton}
    onContinue={onContinue}
    continueButtonText={continueButtonText}
    selectionEnabled={selectionEnabled}
    addressFormSubmitButtonText={addressFormSubmitButtonText}
    newAddressFormTitle={newAddressFormTitle}
    designSystemForms={designSystemForms}
    stayOnAddressFormAfterSave={stayOnAddressFormAfterSave}
    onValidAddressChange={onValidAddressChange}
    hideAddressFormBackLink={hideAddressFormBackLink}
  >
    <AddressesContainerContent />
  </AddressesProvider>
);

export default AddressesContainer;
